import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-container-xl q-col-12 q-d-block q-d-lg-none q-pb-3 q-px-3" }

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs, inject} from "vue";


import {SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'ClearFiltersButtonMobile',
  setup(__props) {

const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasSelectedFilters))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "mobile-filters--clear-button q-btn q-w-100 q-btn-outline-danger q-mb-1",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).clearSelectedFilters && _unref(filtersStore).clearSelectedFilters(...args)))
        }, _toDisplayString(_unref(SmartSearchTranslations).filters.clear), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})